import { render } from "./DecorationProp.vue?vue&type=template&id=f2e4dcc8"
import script from "./DecorationProp.vue?vue&type=script&lang=js"
export * from "./DecorationProp.vue?vue&type=script&lang=js"

import "./DecorationProp.vue?vue&type=style&index=0&id=f2e4dcc8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__